import React, { useRef , useState} from "react";
import Frame from "./Frame";
import {Box, useTheme, Typography,Button, ButtonBase, IconButton,Tooltip, Dialog,DialogActions, DialogTitle,DialogContent, DialogContentText} from "@mui/material";
import { tokens } from "../../theme";
import { useDispatch, useSelector } from "react-redux";
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import ColorizeIcon from '@mui/icons-material/Colorize';
import BrushIcon from '@mui/icons-material/Brush';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { setTool} from "../../slices/sign_image_editor"

const ToolArea = (props) =>  {

  const {} = props;

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const dispatch = useDispatch();

  const selectedTool = useSelector((state) => state.imageEditor.selectedTool);

  const [open, setOpen] = React.useState(false);

  const changeTool = (tool) => {

    dispatch(setTool(tool));

  } 

  const clearFrame = () => {
    //set all pixels to black #000000

  }

  const handleClearOpen = () => {
      setOpen(true);
  };

  const handleClearClose = () => {
    setOpen(false);
  };

  return (
    <>
    <Box
        display = "flex"
        flexDirection="column"
        width = "100%"
        backgroundColor={colors.primary[300]} 
        sx={{ borderRadius:2}}
        p=".5rem 1rem .1rem 1rem"
    >

      <Box dispay="flex" alignContent="center" mb=".2rem">
        <Typography variant="h3" align="center">Tools</Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        mb="1rem"
      >

        <IconButton onClick={() => changeTool("fill")} color={selectedTool === "fill" ? "secondary" : "primary"}>
          <Tooltip title="Fill with the selected colour" enterDelay={500} >
            <FormatColorFillIcon/>
          </Tooltip>
        </IconButton>
        <IconButton onClick={() => changeTool("picker")} color={selectedTool === "picker" ? "secondary" : "primary"}>
          <Tooltip title="Select colour from image" enterDelay={500} >
            <ColorizeIcon/>
          </Tooltip>
        </IconButton>
        <IconButton onClick={() => changeTool("brush")} color={selectedTool === "brush" ? "secondary" : "primary"}>
          <Tooltip title="Brush using the selected colour" enterDelay={500} >
            <BrushIcon/>
          </Tooltip>
        </IconButton>
        <IconButton onClick={() => changeTool("move")} color={selectedTool === "move" ? "secondary" : "primary"}>
          <Tooltip title="Move image withn frame" enterDelay={500} > 
            <OpenWithIcon/>
          </Tooltip>
        </IconButton>
        <IconButton onClick={() => changeTool("eraser")} color={selectedTool === "eraser" ? "secondary" : "primary"}>
          <Tooltip title="Eraser" enterDelay={500} >
            <ClearAllIcon/>
          </Tooltip>
        </IconButton>
        <IconButton onClick={handleClearOpen} color="primary">
          <Tooltip title="Clear entire frame" enterDelay={500} >
            <RestartAltIcon/>
          </Tooltip>
        </IconButton>
      </Box>


      

      

    </Box>

      <Dialog open={open} maxWidth="xs">
      <DialogTitle>Realy Clear Frame</DialogTitle>
      <DialogContent >
        <DialogContentText>
          Completly clear the frame of all drawings
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained"  color="error"  onClick={handleClearClose}>Cancel</Button>
        <Button variant="contained"  color="secondary"  onClick={clearFrame}>Yes</Button>
      </DialogActions>
      </Dialog>

      </>


  );
}

export default ToolArea;